var iconButton = "icon-button__iconButton__CTj--";
var largeSize = "icon-button__largeSize__jKNM1";
var fullRadius = "icon-button__fullRadius__0i-4D";
var ghost = "icon-button__ghost__1ok6j";
var secondary = "icon-button__secondary__-jfOG";
var highlighted = "icon-button__highlighted__KBgcS";
var primary = "icon-button__primary__R4q5D";

export { fullRadius, ghost, highlighted, iconButton, largeSize, primary, secondary };
//# sourceMappingURL=icon-button.module.css.js.map
